import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";
import { get, downloadCsv, btnDark, Card, fmtDate, Empty } from "./shared";

export const Newsletter = () => {
  const [rows, setRows] = useState(null);
  useEffect(() => { get("/newsletter").then(setRows).catch(() => setRows([])); }, []);
  const exportCsv = () => downloadCsv("/newsletter/export.csv", "nura-newsletter.csv").catch(() => toast.error("Export impossible"));
  return (
    <div className="space-y-4" data-testid="admin-newsletter">
      <div className="flex items-center justify-between gap-4">
        <p className="text-sm text-stone-600">{rows?.length ?? "…"} abonné(s). Export CSV compatible avec Mailchimp, Brevo, etc.</p>
        <button data-testid="newsletter-export" onClick={exportCsv} className={btnDark}><Download size={13} /> Exporter CSV</button>
      </div>
      {rows === null ? <Empty>Chargement…</Empty> : rows.length === 0 ? <Empty>Aucun abonné.</Empty> : (
        <Card className="p-6">
          <ul className="grid sm:grid-cols-2 gap-x-8">
            {rows.map((n) => (
              <li key={n.id} className="flex justify-between border-b border-stone-100 py-2 text-sm">
                <span className="font-mono text-stone-700">{n.email}</span><span className="text-xs text-stone-400">{fmtDate(n.created_at)}</span>
              </li>
            ))}
          </ul>
        </Card>
      )}
    </div>
  );
};
